import { ActionIcon, Box, Divider, Flex, Group, Image, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { FooterAnchor, FooterDivider, Section, SectionText } from 'components';
import { EMAIL_ICON, FACEBOOK_ICON, INSTAGRAM_ICON, LINKEDIN_ICON, LOCATION_ICON, LOGO_IMG, PHONE_ICON } from 'constants/app';
import { ROUTE_IMPRESSUM, ROUTE_PRIVACY_POLICY, ROUTE_TERMS_OF_USE } from 'constants/route';
import classes from './index.module.css';

const Footer = () => {
    const { t } = useTranslation();

    const contactInfo = [
        { iconSrc: EMAIL_ICON, text: t('footer.email') },
        { iconSrc: PHONE_ICON, text: t('footer.phone') },
        { iconSrc: LOCATION_ICON, text: t('footer.location') },
    ];

    const socialLinks = [
        { iconSrc: FACEBOOK_ICON, alt: t('footer.facebook.alt'), href: t('footer.facebook.href') },
        { iconSrc: INSTAGRAM_ICON, alt: t('footer.instragram.alt'), href: t('footer.instagram.href') },
        { iconSrc: LINKEDIN_ICON, alt: t('footer.linkedin.alt'), href: t('footer.linkedin.href') },
    ];

    return (
        <Box className={classes.wrapper}>
            <Section footer={true}>
                <Stack align='center' className={classes.stack}>
                    <Stack gap={28} align='center' maw={815}>
                        <Image src={LOGO_IMG} className={classes.logo} />
                        <SectionText text={t('footer.license')} center={true} />
                    </Stack>
                    <SectionText text={t('footer.name')} center={true} />
                    <FooterDivider />
                    <Flex direction={{ base: 'column', sm: 'row' }} gap={20} align={{ base: 'center', sm: 'flex-start' }}>
                        {contactInfo.map(({ iconSrc, text }) => (
                            <Group gap={4} key={text} className={classes.infoBox}>
                                <Image h='auto' w='auto' src={iconSrc} />
                                <SectionText text={text} />
                            </Group>
                        ))}
                    </Flex>
                    <FooterDivider />
                    <Stack gap={24} w='100%' align='center'>
                        <Flex direction={{ base: 'column', md: 'row' }} gap={{ base: 16, md: 0 }} w='100%' justify='space-between' align='center' className={classes.linksBox}>
                            <Group gap={12}>
                                {socialLinks.map(({ iconSrc, alt, href }) => (
                                    <ActionIcon component='a' type='button' href={href} className={classes.social} key={alt} aria-label={alt} target='_blank'>
                                        <Image h='auto' w='auto' src={iconSrc} alt={alt} />
                                    </ActionIcon>
                                ))}
                            </Group>
                            <Group gap={12} justify='center'>
                                <FooterAnchor href={ROUTE_PRIVACY_POLICY} text={t('footer.links.0')} />
                                <Divider orientation='vertical' className={classes.linkDivider} />
                                <FooterAnchor href={ROUTE_TERMS_OF_USE} text={t('footer.links.1')} />
                                <Divider orientation='vertical' className={classes.linkDivider} />
                                <FooterAnchor href={ROUTE_IMPRESSUM} text={t('footer.links.2')} />
                            </Group>
                        </Flex>
                        <SectionText center={true} text={t('footer.restriction')} variant='lighter' />
                    </Stack>
                </Stack>
            </Section>
        </Box>
    )
}

export default Footer;